export default ['$q', 'JsonRPCService', 'policyjob.endpointConfig', 'policyjob.xCenterRouteConfig', function ($q, JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var xCenterRoute = xCenterRouteConfig;
    var endpoint = endpointConfig.vinlookup;

    return {
        autofillBasedOnVIN: function autofillBasedOnVIN(vin) {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'lookupBasedOnVIN', [vin]).then(function (vehicleInfo) {
                return deferred.resolve(vehicleInfo);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        autofillBasedOnPartialDto: function autofillBasedOnPartialDto(dto) {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'lookupBasedOnPartialDTO', [dto]).then(function (vehicleInfo) {
                return deferred.resolve(vehicleInfo);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },
        lookupMakes: function lookupMakes() {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'lookupMakes', []).then(function (vehicleInfo) {
                return deferred.resolve(vehicleInfo);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policyjob/services/VinLookupService.js
// module id = 164
// module chunks = 0